import { takeEvery, put, call } from 'redux-saga/effects';
import {
  GET_TRANSFERS,
  GET_STATUS_TRANSFERS,
  GET_COMPLETED_TRANSFERS,
  GET_FILTERED_TRANSFERS_MOSCOW,
  GET_AGENTS,
  ADD_AGENT,
  UPDATE_AGENT,
  DELETE_AGENT,
  GET_TRANSFERS_MOSCOW,
  GET_TRANSFERS_MOSCOW_LIST,
  ADD_TRANSFER_MOSCOW,
  UPDATE_TRANSFER_MOSCOW,
  DELETE_TRANSFER_MOSCOW,
  GET_TRANSFERS_PRIORITY,
  ADD_TRANSFER_PRIORITY,
  UPDATE_TRANSFER_PRIORITY,
  DELETE_TRANSFER_PRIORITY,
  GET_TRANSFERS_SHIPPING,
  UPDATE_TRANSFER_MOSCOW_DATA,
  DELETE_TRANSFER_SHIPPING
} from './actionTypes';
import {
  getTransfersSuccess,
  getTransfersFail,
  getStatusTransfersSuccess,
  getStatusTransfersFail,
  getCompletedTransfersSuccess,
  getCompletedTransfersFail,
  getFilteredTransfersMoscowSuccess,
  getFilteredTransfersMoscowFail,
  getAgentsSuccess,
  getAgentsFail,
  addAgentSuccess,
  addAgentFail,
  updateAgentSuccess,
  updateAgentFail,
  deleteAgentSuccess,
  deleteAgentFail,
  getTransfersMoscowSuccess,
  getTransfersMoscowFail,
  getTransfersMoscowListSuccess,
  getTransfersMoscowListFail,
  addTransferMoscowSuccess,
  addTransferMoscowFail,
  updateTransferMoscowSuccess,
  updateTransferMoscowFail,
  deleteTransferMoscowSuccess,
  deleteTransferMoscowFail,
  getTransfersPrioritySuccess,
  getTransfersPriorityFail,
  addTransferPrioritySuccess,
  addTransferPriorityFail,
  updateTransferPrioritySuccess,
  updateTransferPriorityFail,
  deleteTransferPrioritySuccess,
  deleteTransferPriorityFail,
  getTransfersShippingSuccess,
  getTransfersShippingFail,
  updateTransferMoscowDataSuccess,
  updateTransferMoscowDataFail,
  deleteTransferShippingSuccess,
  deleteTransferShippingFail,
  showLoading,
  hideLoading
} from './actions';
import {
  getTransfersInfo,
  getSpecTransfer,
  getCompletedTransfer,
  getFilteredTransferMoscow,
  getAgentsInfo,
  addAgent,
  updateAgent,
  deleteAgent,
  getTransfersMoscow,
  getTransfersMoscowList,
  addTransferMoscow,
  updateTransferMoscow,
  deleteTransferMoscow,
  getTransfersPriority,
  addTransferPriority,
  updateTransferPriority,
  deleteTransferPriority,
  getTransfersShipping,
  updateTransferMoscowData,
  deleteTransferShipping
} from '../../helpers/backend_helper';
import { showToast } from '../../components/Toast';

/*NOT SOCKET CONNECTION*/
function* fetchTransfersInfo() {
  try {
    yield put(showLoading(true));
    const response = yield call(getTransfersInfo);
    yield put(getTransfersSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getTransfersFail(error));
  }
}
function* getSpecTransfers({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getSpecTransfer, id);
    yield put(getStatusTransfersSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(getStatusTransfersFail(error));
  }
}

function* getCompletedTransfers({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getCompletedTransfer, id);
    yield put(getCompletedTransfersSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(getCompletedTransfersFail(error));
  }
}

function* getFilteredTransfersMoscow({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getFilteredTransferMoscow, id);
    yield put(getFilteredTransfersMoscowSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(getFilteredTransfersMoscowFail(error));
  }
}

function* fetchAgentsInfo() {
  try {
    yield put(showLoading(true));
    const response = yield call(getAgentsInfo);
    yield put(getAgentsSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getAgentsFail(error));
  }
}

function* onAddAgent({ payload: agent }) {
  try {
    yield put(showLoading(true));
    const response = yield call(addAgent, agent);
    showToast('New Agent is added');
    yield put(addAgentSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(addAgentFail(error.response));
  }
}
function* onUpdateAgent({ payload: agent }) {
  try {
    yield put(showLoading(true));
    const response = yield call(updateAgent, agent);
    showToast('Changes Successfully Applied');
    yield put(updateAgentSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(updateAgentFail(error));
  }
}
function* onDeleteAgent({ payload: agent }) {
  try {
    yield put(showLoading(true));
    const response = yield call(deleteAgent, agent);
    showToast('Agent is deleted from the system');
    yield put(deleteAgentSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(deleteAgentFail(error));
  }
}

function* fetchTransfersMoscow() {
  try {
    yield put(showLoading(true));
    const response = yield call(getTransfersMoscow);
    yield put(getTransfersMoscowSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getTransfersMoscowFail(error));
  }
}

function* fetchTransfersMoscowList() {
  try {
    yield put(showLoading(true));
    const response = yield call(getTransfersMoscowList);
    yield put(getTransfersMoscowListSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getTransfersMoscowListFail(error));
  }
}
function* onTransferMoscow({ payload: transfer_moscow }) {
  try {
    yield put(showLoading(true));
    const response = yield call(addTransferMoscow, transfer_moscow);
    showToast('New Transfer Order is added');
    yield put(addTransferMoscowSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(addTransferMoscowFail(error.response));
  }
}
function* onUpdateTransferMoscow({ payload: transfer_moscow }) {
  try {
    yield put(showLoading(true));
    const response = yield call(updateTransferMoscow, transfer_moscow);
    showToast('Changes Successfully Applied');
    yield put(updateTransferMoscowSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(updateTransferMoscowFail(error));
  }
}
function* onDeleteTransferMoscow({ payload: transfer_moscow }) {
  try {
    yield put(showLoading(true));
    const response = yield call(deleteTransferMoscow, transfer_moscow);
    showToast('Order is deleted from the system');
    yield put(deleteTransferMoscowSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(deleteTransferMoscowFail(error));
  }
}

function* fetchTransfersPriority() {
  try {
    yield put(showLoading(true));
    const response = yield call(getTransfersPriority);
    yield put(getTransfersPrioritySuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getTransfersPriorityFail(error));
  }
}
function* onTransferPriority({ payload: transfer_priority }) {
  try {
    yield put(showLoading(true));
    const response = yield call(addTransferPriority, transfer_priority);
    showToast('New Transfer Order is added');
    yield put(addTransferPrioritySuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(addTransferPriorityFail(error.response));
  }
}
function* onUpdateTransferPriority({ payload: transfer_priority }) {
  try {
    yield put(showLoading(true));
    const response = yield call(updateTransferPriority, transfer_priority);
    showToast('Changes Successfully Applied');
    yield put(updateTransferPrioritySuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(updateTransferPriorityFail(error));
  }
}
function* onDeleteTransferPriority({ payload: transfer_priority }) {
  try {
    yield put(showLoading(true));
    const response = yield call(deleteTransferPriority, transfer_priority);
    showToast('Order is deleted from the system');
    yield put(deleteTransferPrioritySuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(deleteTransferPriorityFail(error));
  }
}

function* fetchTransfersShipping() {
  try {
    yield put(showLoading(true));
    const response = yield call(getTransfersShipping);
    yield put(getTransfersShippingSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getTransfersShippingFail(error));
  }
}

function* onUpdateTransferMoscowData({ payload: transfer_moscow_data }) {
  try {
    yield put(showLoading(true));
    const response = yield call(updateTransferMoscowData, transfer_moscow_data);
    showToast('Transfer Shipping has been updated');
    if (transfer_moscow_data.option && transfer_moscow_data.option === 'make_row_completed') {
      yield put(deleteTransferShippingSuccess(response[0]));
    }
    if (transfer_moscow_data.option && transfer_moscow_data.option === 'make_row_not_completed') {
      yield put(deleteTransferShippingSuccess(response[0]));
    }
    yield put(updateTransferMoscowDataSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(updateTransferMoscowDataFail(error.response));
  }
}

function* onDeleteTransferShipping({ payload: transfers_shipping }) {
  try {
    yield put(showLoading(true));
    const response = yield call(deleteTransferShipping, transfers_shipping);
    showToast('Order is deleted from the system');
    yield put(deleteTransferShippingSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(deleteTransferShippingFail(error));
  }
}

/*NOT SOCKET CONNECTION*/

function* transfersSaga() {
  yield takeEvery(GET_TRANSFERS, fetchTransfersInfo);
  yield takeEvery(GET_STATUS_TRANSFERS, getSpecTransfers);
  yield takeEvery(GET_COMPLETED_TRANSFERS, getCompletedTransfers);
  yield takeEvery(GET_FILTERED_TRANSFERS_MOSCOW, getFilteredTransfersMoscow);
  yield takeEvery(GET_AGENTS, fetchAgentsInfo);
  yield takeEvery(ADD_AGENT, onAddAgent);
  yield takeEvery(UPDATE_AGENT, onUpdateAgent);
  yield takeEvery(DELETE_AGENT, onDeleteAgent);

  yield takeEvery(GET_TRANSFERS_MOSCOW, fetchTransfersMoscow);
  yield takeEvery(GET_TRANSFERS_MOSCOW_LIST, fetchTransfersMoscowList);
  yield takeEvery(ADD_TRANSFER_MOSCOW, onTransferMoscow);
  yield takeEvery(UPDATE_TRANSFER_MOSCOW, onUpdateTransferMoscow);
  yield takeEvery(DELETE_TRANSFER_MOSCOW, onDeleteTransferMoscow);

  yield takeEvery(GET_TRANSFERS_PRIORITY, fetchTransfersPriority);
  yield takeEvery(ADD_TRANSFER_PRIORITY, onTransferPriority);
  yield takeEvery(UPDATE_TRANSFER_PRIORITY, onUpdateTransferPriority);
  yield takeEvery(DELETE_TRANSFER_PRIORITY, onDeleteTransferPriority);

  yield takeEvery(GET_TRANSFERS_SHIPPING, fetchTransfersShipping);
  yield takeEvery(UPDATE_TRANSFER_MOSCOW_DATA, onUpdateTransferMoscowData);
  yield takeEvery(DELETE_TRANSFER_SHIPPING, onDeleteTransferShipping);
}

export default transfersSaga;
